const CHART_SERIES_COLOR_COUNT = 10;

export const chartSeriesColor = (index: number): string => {
  const integerIndex = Number.isFinite(index) ? Math.trunc(index) : 0;
  const normalizedIndex =
    ((integerIndex % CHART_SERIES_COLOR_COUNT) + CHART_SERIES_COLOR_COUNT) % CHART_SERIES_COLOR_COUNT;

  return `var(--chart-series-${normalizedIndex + 1})`;
};
